// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__dUSRB","validationTips":"StatementDescriptor_validationTips__2-sQd"};